// src/components/StockoutTable.jsx
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  IconButton,
  Box,
  Typography,
  TableFooter,
  TablePagination
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const StockoutTable = ({ rows, summary, themeColors }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const displayRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer
      component={Paper}
      sx={{
        maxHeight: "65vh",
        border: 2,
        borderColor: "divider",
        borderRadius: 1,
      }}
    >
      <Table stickyHeader>
        <TableHead sx={{ backgroundColor: themeColors.blueAccent[700] }}>
          <TableRow>
            <TableCell />
            <TableCell>Stock Out Date</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Warehouse</TableCell>
            <TableCell>Car</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {displayRows.map((row) => (
            <StockoutRow key={row.id} row={row} themeColors={themeColors} />
          ))}
        </TableBody>

        {/* Totals Row */}
        <TableFooter>
          <TableRow sx={{ backgroundColor: themeColors.primary[400] }}>
            <TableCell colSpan={3} align="right" sx={{ fontWeight: "bold" }}>
              Totals:
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              {summary.totalStockouts || 0}
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              {/* {summary.totalQuantity || 0} */}
            </TableCell>
            <TableCell />
          </TableRow>
        </TableFooter>
      </Table>

      <TablePagination
        component="div"
        count={rows.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </TableContainer>
  );
};

const StockoutRow = ({ row, themeColors }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow hover sx={{ cursor: "pointer" }}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{dayjs.utc(row.createdAt).format("YYYY-MM-DD")}</TableCell>
        <TableCell>{row.user}</TableCell>
        <TableCell>{row.warehouse}</TableCell>
        <TableCell>{row.car || "-"}</TableCell>
        <TableCell>{row.status}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Items
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell align="right">Qty</TableCell>
                    <TableCell align="right">Bonus</TableCell>
                    <TableCell align="right">Sponsor</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.items?.map((item, idx) => (
                    <TableRow key={idx} sx={{ "&:last-child td": { border: 0 } }}>
                      <TableCell>{item.itemName}</TableCell>
                      <TableCell align="right">{item.amount}</TableCell>
                      <TableCell align="right">{item.bonus}</TableCell>
                      <TableCell align="right">{item.sponsor}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default StockoutTable;
